import Type from "./Type";

const TypeFilter = (props) => {
    return(
        <div className="filter-box">
            <h2>
                Pokemon Type
            </h2>
            {
                props.types.map((type) => 
                    <Type
                        key = {type}
                        type = {type}
                    />
                )
            }
        </div>
    )
}

export default TypeFilter;